export default "__VITE_PUBLIC_ASSET__193c1e2a__"